module.exports = __webpack_public_path__ + "img/img_4.904f3567.png";